import { render, staticRenderFns } from "./Recipe.vue?vue&type=template&id=31c6a84e&"
import script from "./Recipe.vue?vue&type=script&lang=js&"
export * from "./Recipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports